/* eslint-disable */
require('./10')
require('./12')
require('./16')
require('./24')
require('./32')
require('./64')
